import axios from "axios";
import React, { useContext, useEffect, useState } from "react";
import { useParams, Link, useLocation, useNavigate } from "react-router-dom";
import { AiOutlinePhone } from "react-icons/ai";
import { MdOutlineMailOutline } from "react-icons/md";
import qs from "qs";
import { FECTH_ALL_AGENTS_STRAPI } from "../../api/constants";

import { FaWhatsapp } from "react-icons/fa";
import ReactPlayer from "react-player/lazy";

import { Helmet } from "react-helmet";
import { useMediaQuery } from "react-responsive";
import { WebsiteContext } from "../../context/websiteContext";
import ReadMoreArea from "@foxeian/react-read-more";
import FindYourDreamHomeV1 from "../FIndYourDreamHome/FindYourDreamHomeV1";

export default function AgentDetailV1() {
  const { agentName } = useParams();
  const { setShowAreas } = useContext(WebsiteContext);

  const isSmallScreen = useMediaQuery({ maxWidth: 465 });

  const isBigScreen = useMediaQuery({ minWidth: 1025 });

  const [agent, setAgent] = useState();
  const { pathname } = useLocation();

  const navigate = useNavigate();

  useEffect(() => {
    const fetchDatafromStrapi = async () => {
      const query = qs.stringify(
        {
          filters: {
            show_profile: true,
            name_slug: agentName,
          },

          populate: "*",
        },
        {
          encodeValuesOnly: true, // prettify URL
        }
      );
      try {
        const response = await axios.get(`${FECTH_ALL_AGENTS_STRAPI}?${query}`);

        setAgent(response?.data?.data[0]);
        if (!response?.data?.data[0]) {
          navigate("/agent/");
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchDatafromStrapi();
  }, [agentName]);

  useEffect(() => {
    setShowAreas(false);
  }, []);

  return (
    <>
      <Helmet>
        <link
          rel="alternate"
          hreflang="en-ae"
          href={`https://www.xrealty.ae/${pathname.replace("/", "")}`}
        />
        <link
          rel="alternate"
          hreflang="en-us"
          href={`https://www.xrealty.ae/${pathname.replace("/", "")}`}
        />
        <link
          rel="alternate"
          hreflang="en-gb"
          href={`https://www.xrealty.ae/${pathname.replace("/", "")}`}
        />
        <link
          rel="alternate"
          hreflang="en-sg"
          href={`https://www.xrealty.ae/${pathname.replace("/", "")}`}
        />
        <link
          rel="alternate"
          hreflang="en-in"
          href={`https://www.xrealty.ae/${pathname.replace("/", "")}`}
        />
        <link
          rel="alternate"
          hreflang="en"
          href={`https://www.xrealty.ae/${pathname.replace("/", "")}`}
        />
        <link
          rel="alternate"
          hreflang="x-default"
          href={`https://www.xrealty.ae/${pathname.replace("/", "")}`}
        />

        {/* <script type="application/ld+json">
          {JSON.stringify(agent?.schema_org?.properties)}
        </script> */}
      </Helmet>
      <div className="bg-white">
        {/* Hero Section */}
        <div className="pt-8 md:pt-12">
          <div>
            <div className="grid sm:grid-cols-2 md:grid-cols-2 gap-4 px-4 md:px-8 xl:px-16 md:mx-auto xl:max-w-7xl xl:mx-auto 2xl:px-0">
              {/* Image Column */}
              <div className="w-full h-full md:h-[600px] xl:h-[700px] 2xl:h-[700px]">
                <img
                  src={
                    agent?.profile_picture?.formats?.large?.url ||
                    agent?.profile_picture?.url
                  }
                  alt={agent?.alternativeText}
                  className="w-full h-full object-cover lg:object-contain xl:object-contain 2xl:object-contain"
                />
              </div>

              {/* Info Column */}
              <div className="space-y-8">
                <div>
                  <h1 className="text-2xl md:text-4xl font-[optima-lt-pro] mb-2 text-black uppercase">
                    {agent?.name}
                  </h1>
                  <p className="text-sm md:text-base text-bhagwa font-[lato] uppercase">
                    {agent?.designation}
                  </p>
                </div>

                {/* Experience Info */}
                <div className="space-y-4 border-t border-gray-300 pt-6">
                  <div className="grid grid-cols-2 gap-x-8 gap-y-4">
                    <div>
                      <p className="text-black font-[optima-lt-pro]">
                        Experience:
                      </p>
                      <p className="text-black font-[lato]">
                        {agent?.experience} years
                      </p>
                    </div>

                    {agent?.specialities && (
                      <div>
                        <p className="text-black font-[optima-lt-pro]">
                          Specialization:
                        </p>
                        <p className="text-black font-[lato]">
                          {agent?.specialities}
                        </p>
                      </div>
                    )}

                    <div>
                      <p className="text-black font-[optima-lt-pro]">
                        Language:
                      </p>
                      <p className="text-black font-[lato]">
                        {agent?.languages}
                      </p>
                    </div>
                  </div>
                </div>

                {/* Contact Buttons */}
                <div className="grid grid-cols-3 gap-4 pt-6">
                  <a
                    rel="nofollow noreferrer"
                    href={`tel:${agent?.phone_no}`}
                    className="flex items-center justify-center gap-2 border border-gray-300 py-3 px-4 text-black hover:text-white hover:bg-bhagwa transition"
                  >
                    <AiOutlinePhone className="w-5 h-5" />
                  </a>
                  <a
                    rel="nofollow"
                    href={`mailto:${agent?.email}`}
                    className="flex items-center justify-center gap-2 border border-gray-300  py-3 px-4 text-blue-400 hover:text-white hover:bg-bhagwa transition"
                  >
                    <MdOutlineMailOutline className="w-5 h-5" />
                  </a>
                  <a
                    href={`https://wa.me/${agent?.phone_no}?text=Hello ${agent?.name}, saw your profile on Xperience Realty Website, can we connect?`}
                    target="_blank"
                    rel="noreferrer nofollow"
                    className="flex items-center justify-center gap-2 border border-gray-300  py-3 px-4 text-green-600  hover:bg-bhagwa hover:text-white transition"
                  >
                    <FaWhatsapp className="w-5 h-5" />
                  </a>
                </div>

                {/* About Section */}
                {true && (
                  <div>
                    <h2 className="text-2xl uppercase font-[optima-lt-pro] mb-2">
                      About
                    </h2>
                    <p className="prose max-w-none font-[lato] text-black font-light text-justify leading-relaxed">
                      {isBigScreen || isSmallScreen ? (
                        <>{agent?.bio}</>
                      ) : (
                        <ReadMoreArea lettersLimit={400}>
                          {agent?.bio}
                        </ReadMoreArea>
                      )}
                    </p>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>

        {/* About Section Tablet Only */}
        {false && (
          <div className="container mx-auto px-4 py-16">
            <div className="max-w-6xl mx-auto">
              <h2 className="text-2xl uppercase font-[optima-lt-pro] mb-6">
                About
              </h2>
              <div className="prose max-w-none">
                <p className="text-black text-justify font-light font-[lato] leading-relaxed">
                  {agent?.bio}
                </p>
              </div>
            </div>
          </div>
        )}

        {/* Videos Section */}
        {agent?.video_links?.length > 0 ? (
          <div className="py-16 px-4 md:px-8 xl:px-16 md:mx-auto xl:max-w-7xl xl:mx-auto 2xl:px-0">
            <div>
              <h2 className="text-2xl uppercase font-[optima-lt-pro] mb-4">
                Featured Videos
              </h2>
              <div className="grid sm:grid-cols-2 gap-8">
                {agent?.video_links?.map((item, i) => (
                  <div
                    key={i}
                    className="aspect-video overflow-hidden shadow-lg"
                  >
                    <ReactPlayer url={item?.url} width="100%" height="100%" />
                  </div>
                ))}
              </div>
            </div>
          </div>
        ) : (
          <div className="mt-4 bg-[url('https://res.cloudinary.com/dkhns25jh/image/upload/w_1280,f_auto,q_auto/v1745218644/xr_media/zosz2w8ve8l1swkgzfs4.png')] md:bg-[url('https://res.cloudinary.com/dkhns25jh/image/upload/w_1920,f_auto,q_auto/v1745218644/xr_media/zosz2w8ve8l1swkgzfs4.png')] bg-cover bg-no-repeat bg-center">
            <div className="px-4 md:px-8 xl:px-16 md:mx-auto xl:max-w-7xl xl:mx-auto 2xl:px-0">
              <FindYourDreamHomeV1 />
            </div>
          </div>
        )}
      </div>
    </>
  );
}
